import React from "react";
import "./Events.css";

import Img1 from "../../assets/Events/Copy of EVENT.jpg";

const eventItems = [
  {
    title: "BOMBAY AMUSEMENT RIDE",
    category: "EVENT FILM",

    description:
      "Bringing the makers of unforgettable thrills into the spotlight.",

    note:
      "I volunteered to film from the ground. Purely for stability.",

    eyebrow: "THRILLS • ENERGY • EXPERIENCE",

    image: Img1,
  },
];

const categories = [
  "CAMPAIGNS",
  "COMMERCIALS",
  "BRAND FILMS",
  "CORPORATE FILMS",
  "DOCUMENTARIES",
  "EVENTS",
  "PODCASTS & INTERVIEWS",
  "SOCIAL AND VERTICAL FILMS",
  "PHOTOGRAPHY CREATIVE",
];

function goToSlug(category) {
  return category
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/\s+/g, "-");
}

function Events() {
  const goToCategory = (category) => {
    const routes = {
        "CAMPAIGNS": "/campaigns",
        "COMMERCIALS": "/commercials",
        "BRAND FILMS": "/brand-films",
        "CORPORATE FILMS": "/corporate-films",
        "DOCUMENTARIES": "/documentaries",
        "PODCASTS & INTERVIEWS": "/podcasts",
    };

    const route = routes[category];

    if (route) {
        window.location.href = route;
    }
};

  return (
    <main className="events-page">

      <div className="events-shell">

        {/* =========================================
            HEADER
        ========================================= */}

        <header className="events-main-header">

          <div className="events-eyebrow">
            <span></span>
            THE EVENT ARCHIVE
            <span></span>
          </div>

          <h1 className="events-main-title">
            EVENTS
          </h1>

          <div className="events-main-rule">
            <span>
              MOMENTS • ENERGY • EXPERIENCE
            </span>
          </div>

        </header>


        {/* =========================================
            EVENT CONTENT
        ========================================= */}

        <div className="events-content">

          {eventItems.map((item, index) => (

            <article
              className="event-project"
              key={item.title}
            >

              {/* =====================================
                  PROJECT META
              ===================================== */}

              <div className="event-project-meta">

                <span className="event-number">
                  0{index + 1}
                </span>

                <span className="event-meta-label">
                  {item.eyebrow}
                </span>

              </div>


              {/* =====================================
                  PROJECT HEADING
              ===================================== */}

              <div className="event-heading">

                <div className="event-heading-title">

                  <span>
                    EVENT FILM
                  </span>

                  <h2>
                    {item.title}
                  </h2>

                </div>

                <div className="event-heading-line"></div>

              </div>


              {/* =====================================
                  DESCRIPTION + NOTE
              ===================================== */}

              <div className="event-description-wrap">

                <p className="event-description">
                  {item.description}
                </p>

                <p className="event-note">
                  {item.note}
                </p>

              </div>


              {/* =====================================
                  CINEMATIC MEDIA
              ===================================== */}

              <div className="event-media">

                <img
                  src={item.image}
                  alt={item.title}
                  className="event-image"
                />

                <div className="event-overlay"></div>


                {/* TOP LABEL */}

                <div className="event-media-top">

                  <span>
                    EVENT / 01
                  </span>

                  <span>
                    {item.category}
                  </span>

                </div>


                {/* PLAY BUTTON */}

                <button
                  type="button"
                  className="event-play"
                  aria-label={`Play ${item.title}`}
                >
                  <span></span>
                </button>


                {/* MEDIA CENTER LABEL */}

                <div className="event-center-label">
                  <span>PLAY FILM</span>
                </div>


                {/* BOTTOM INFO */}

                <div className="event-info">

                  <div>

                    <h3>
                      {item.title}
                    </h3>

                    <p>
                      {item.category}
                    </p>

                  </div>

                  <span className="event-media-index">
                    01 / 01
                  </span>

                </div>

              </div>


              {/* =====================================
                  PROJECT FOOTER
              ===================================== */}

              <div className="event-project-footer">

                <span>
                  BOMBAY / INDIA
                </span>

                <span>
                  EVENT FILM
                </span>

                <span>
                  01 FRAME
                </span>

              </div>

            </article>

          ))}

        </div>


        {/* =========================================
            CATEGORY NAVIGATION
        ========================================= */}

        <nav className="events-category-bar">

          {/* LEFT */}

          <button
            className="events-nav-arrow"
            onClick={() =>
              goToCategory("DOCUMENTARIES")
            }
            aria-label="Previous category"
          >
            ←
          </button>


          {/* CATEGORIES */}

          <div className="events-category-list">

            {categories.map((category) => (

              <button
                key={category}
                type="button"
                className={`events-category ${
                  category === "EVENTS"
                    ? "active"
                    : ""
                }`}
                onClick={() =>
                  goToCategory(category)
                }
              >
                {category}
              </button>

            ))}

          </div>


          {/* RIGHT */}

          <button
            className="events-nav-arrow"
            onClick={() =>
              goToCategory("PODCASTS & INTERVIEWS")
            }
            aria-label="Next category"
          >
            →
          </button>

        </nav>

      </div>

    </main>
  );
}

export default Events;